/* globals ScrollUtil, ResponsiveUtil */
import { node_observable_component } from 'common/util/ComponentDecorator';
import MaskUtil from "common/util/MaskUtil";
import './checkout-contactinfo.scss';

@node_observable_component
export default class checkoutContactinfo {
	static classname = 'checkout-contactinfo';

	constructor($contactinfo) {
		this.$contactinfo = $contactinfo;
		this.init();
		this.decorate();
		this.handleNocallBlock();
		this.bindEvents();
		this.addClass();
		this.changePhoneField();
	}

	init = () => {
		if (ResponsiveUtil.isToTablet()) {
			const $errorInputs = this.$contactinfo.find('input.error');
			if ($errorInputs.length) {
				ScrollUtil.scrollTo($errorInputs.offset().top - 150);
			}
		}
	};

	decorate = () => {
		const $selects = this.$contactinfo.find('select');
		const $addressFields = this.$contactinfo.find('.wa-field-address input');
		const $addressStreetField = this.$contactinfo.find('.wa-field-address-street input');
		const $addressCityField = this.$contactinfo.find('.wa-field-address-city input');
		const $addressPodezdField = this.$contactinfo.find('.wa-field-address-podezd input');
		const $addressEtazhField = this.$contactinfo.find('.wa-field-address-etazh input');
		const $addressKoddomofonField = this.$contactinfo.find('.wa-field-address-koddomofon input')
		const $addressKvartiraofisField = this.$contactinfo.find('.wa-field-address-kvartiraofis input');

		const $addressCity = this.$contactinfo.find('.wa-field-address-city');
		const $addressStreet = this.$contactinfo.find('.wa-field-address-street');
		const $addressPodezd = this.$contactinfo.find('.wa-field-address-podezd');
		const $addressEtazh = this.$contactinfo.find('.wa-field-address-etazh');
		const $addressKoddomofon = this.$contactinfo.find('.wa-field-address-koddomofon')
		const $addressKvartiraofis = this.$contactinfo.find('.wa-field-address-kvartiraofis');


		$addressCityField.data('label', 'Город');
		$addressStreetField.data('label', 'Улица, дом, квартира');
		$addressPodezdField.data('label', 'Подъезд');
		$addressEtazhField.data('label', 'Этаж');
		$addressKoddomofonField.data('label', 'Код/домофон');
		$addressKvartiraofisField.data('label', 'Квартира/офис');
		$addressFields.addClass('js-formgroup-decorator');

		const removeLabel = (element) => {
			element.find('.custom-label')[0].remove();
		}

		removeLabel($addressCity);
		removeLabel($addressStreet);
		// removeLabel($addressPodezd);
		// removeLabel($addressEtazh);
		// removeLabel($addressKoddomofon);
		// removeLabel($addressKvartiraofis);
		$selects.each(function() {
			const $select = $(this);
			const $selectFieldBlock = $select.closest('.field');
			const $selectLabelBlock = $selectFieldBlock.find('.custom-label');
			const selectLabel = $selectLabelBlock.text();
			let classes = '';

			if ($select.attr('name') === 'customer[address.shipping][country]') {
				if (['rus', 'blr', 'kaz'].indexOf($select.val()) < 0) {
					$select.val('rus');
				};
				$select.find('option:not([value="rus"]):not([value="blr"]):not([value="kaz"]').remove();
				classes += ' select_countries'
			}

			Select.create($select, '', true, classes, selectLabel, $select.attr('name') === 'customer[address.shipping][region]');
		})
	};

	handleNocallBlock = () => {
		const $addressShippingField = this.$contactinfo.find('.wa-field-address-shipping');
		const $noCallField = this.$contactinfo.find('.wa-field-nocall');
		const $yesBtn = this.$contactinfo.find('#plugin_nocall_yes');

		$noCallField.on('click', '.checkbox__label', function () {
			const $radioBtn = $(this).closest('.checkbox').find('input[name="plugin_nocall"]');

			if ($radioBtn.val() === 'no' && $radioBtn.is(':checked')) {
				$yesBtn.trigger('click');
				return false
			}
		});

		$noCallField.insertBefore($addressShippingField);
	};

	bindEvents = () => {
		const statusInputVal = this.$contactinfo.find('input[name="customer[status]"]:checked').val();
		if (!statusInputVal) {
			this.$contactinfo.find('input[name="customer[status]"]').eq(0).prop('checked', true);
		}

	};

	addClass = () => {
		const contactinfoInputs = this.$contactinfo.find('input[name^="customer"][type="text"]');

		contactinfoInputs.addClass('ym-record-keys');
	};

	changePhoneField = () => {
		const $phoneField = this.$contactinfo.find('input[name="customer[phone]"]');

		$phoneField.attr('type', 'tel');
		$phoneField.closest('.wa-field').find('.wa-name').remove();
		MaskUtil.initIntlTelMask($phoneField);
	}
}
